import React, { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import ProTable from 'src/app/common/components/ProTable';
import column from './column';
import { commonStyles } from './style';

const AgentsTable: FC<any> = ({ data, setSeletAgent, actionRef, disabled }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const [selectedRowsState, setSelectedRows] = useState<any>();
  const [pageData, setPageData] = useState<{ [key: string]: any }>({
    pageNum: 0,
    pageSize: 20,
  });

  const formatData = async (newFilterState: any) => {
    const { page, pageSize } = newFilterState;
    const list = data.slice(page * pageSize, page * pageSize + pageSize);

    const res = {
      data: list || [],
      success: true,
      total: data?.length,
    };

    return res;
  };

  const fetchData = (newFilterState: any): Promise<any> => {
    return formatData(newFilterState);
  };

  return (
    <div style={commonStyles.tableBg}>
      <ProTable
        rowKey="key"
        filterTitle={''}
        headerTitle={''}
        columns={column(Translation, data, actionRef, disabled)}
        pageSize={pageData.pageSize}
        request={(params) => {
          return fetchData(params);
        }}
        toolBarRender={() => []}
        rowSelection={{
          onChange: (_: any, selectedRows: any) => {
            const selectCourse = selectedRows && selectedRows[0];
            if (selectCourse) {
              setSelectedRows(selectedRows);
              setSeletAgent(selectedRows);
            } else {
              setSelectedRows([]);
            }
          },
          getCheckboxProps: () => {
            return {
              // disabled: !!data.find((item: any) => item.agentCode === record.agentCode)
            };
          },
        }}
        singleSelect={false}
        hideToolBar={true}
        hideAllSelect={false}
        actionRef={actionRef}
        titleStyle={commonStyles.tableBgColor}
        titleFontStyle={commonStyles.colorBlack}
      />
    </div>
  );
};

export default AgentsTable;
